import apiWithAuth from './apiWithAuth';

const BASE = '/admin-panel/service-bookings';

export const listServiceBookings = (params = {}) =>
  apiWithAuth.get(`${BASE}/bookings`, { params });

export const searchServiceBookings = (params = {}) =>
  apiWithAuth.get(`${BASE}/bookings/search`, { params });

export const filterServiceBookings = (params = {}) =>
  apiWithAuth.get(`${BASE}/bookings/filter`, { params });

export const getServiceBooking = (bookingKey) =>
  apiWithAuth.get(`${BASE}/bookings/${encodeURIComponent(bookingKey)}`);

export function extractBookingFromResponse(data) {
  if (!data) return null;
  if (data.booking?.bookingId) return data.booking;
  if (Array.isArray(data.bookings) && data.bookings.length) return data.bookings[0];
  if (data.bookingId) return data;
  return null;
}

const serviceBookingAdminApi = {
  listServiceBookings,
  searchServiceBookings,
  filterServiceBookings,
  getServiceBooking,
  extractBookingFromResponse
};

export default serviceBookingAdminApi;
